import { getInstance } from "../../app";
import "./style.css";

export default class MindMapControls {
  static selector = ".mind-map-controls";

  constructor(block) {
    this.block = block;
  }

  handleSearchClick = () => {
    window.App.modals.technologysearch.open();
  };

  onReady() {
    this.searchButton = this.block.querySelector(".mind-map-controls__search");

    setTimeout(() => {
      this.wheelInstance = getInstance(document.querySelector(".mind-map"));
    }, 200);

    if (this.searchButton) {
      this.searchButton.addEventListener("click", this.handleSearchClick);
    }
  }

  onResize() {}

  onDestroy() {
    if (this.searchButton) {
      this.searchButton.removeEventListener("click", this.handleSearchClick);
    }
  }
}
